import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-light-svg-icons';

import styles from './index.module.sass';

const Account: FC = () => {
  const handleClick = () => {
    // TODO
  };

  return (
    <button className={styles.button} type="button" onClick={handleClick}>
      <FontAwesomeIcon className={styles.icon} icon={faUser} />
    </button>
  );
};

export default Account;
